import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/403',
      component: () => import(/* webpackChunkName: "403" */ '@/views/403.vue'),
      meta: {
        title: '403'
      }
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: {
        title: '404'
      }
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/',
      name: 'home',
      redirect: '/home',
      component: () => import(/* webpackChunkName: "layout" */ '@/views/layout/index.vue'),
      children: [
        {
          path: '/home',
          component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/index.vue'),
          name: 'home',
          meta: { title: '系统总览', keepAlive: true }
        },
        {
          path: '/about',
          component: () => import(/* webpackChunkName: "about" */ '@/views/about.vue'),
          name: 'about',
          meta: { title: '关于程序', keepAlive: true }
        },

        {
          path: '/manage/group',
          component: () => import(/* webpackChunkName: "manage_group" */ '@/views/manage/group/index.vue'),
          name: 'manage_group',
          meta: { title: '团队列表' }
        },

        {
          path: '/manage/system',
          component: () => import(/* webpackChunkName: "manage_system" */ '@/views/manage/system/index.vue'),
          name: 'manage_system',
          meta: { title: '界面管理' }
        },

        {
          path: '/manage/user',
          component: () => import(/* webpackChunkName: "manage_user" */ '@/views/manage/user/index.vue'),
          name: 'manage_user',
          meta: { title: '用户列表' }
        },
        {
          path: '/manage/user_edit',
          component: () => import(/* webpackChunkName: "manage_user_edit" */ '@/views/manage/user/edit.vue'),
          name: 'manage_user_edit',
          meta: { title: '用户编辑' }
        },
        {
          path: '/system/config',
          component: () => import(/* webpackChunkName: "manage_config" */ '@/views/manage/config/index.vue'),
          name: 'manage_config',
          meta: { title: '系统配置' }
        },
        {
          path: '/system/account',
          component: () => import(/* webpackChunkName: "manage_account" */ '@/views/manage/changePassword/index.vue'),
          name: 'manage_account',
          meta: { title: '修改密码' }
        },
        {
          path: '/system/role',
          component: () => import(/* webpackChunkName: "manage_role" */ '@/views/manage/role/index.vue'),
          name: 'manage_role',
          meta: { title: '角色管理' }
        },

        {
          path: '/manage/ipp',
          component: () => import(/* webpackChunkName: "manage_ipp" */ '@/views/manage/ipp/index.vue'),
          name: 'manage_ipp',
          meta: { title: '站位管理' }
        },
        {
          path: '/manage/ipp_edit',
          component: () => import(/* webpackChunkName: "manage_ipp_edit" */ '@/views/manage/ipp/edit.vue'),
          name: 'manage_ipp_edit',
          meta: { title: '站位管理编辑' }
        },

        {
          path: '/ipp/ipp-view',
          component: () => import(/* webpackChunkName: "ipp-view" */ '@/views/ipp/ipp-view/index.vue'),
          name: 'ipp-view',
          meta: { title: '站位预览页' }
        },
        {
          path: '/ipp/ipp-view-detail',
          component: () => import(/* webpackChunkName: "ipp-view-detail" */ '@/views/ipp/ipp-view-detail/index.vue'),
          name: 'ipp-view-detail',
          meta: { title: '数据详情页', keepAlive: true }
        },
        {
          path: '/ipp/ipp-image-detail',
          component: () => import(/* webpackChunkName: "ipp-image-detail" */ '@/views/ipp/ipp-image-detail/index.vue'),
          name: 'ipp-image-detail',
          meta: { title: '图片详情页' }
        },
        {
          path: '/identify',
          component: () => import(/* webpackChunkName: "identify" */ '@/views/ipp/ipp-view-detail/identify.vue'),
          name: 'identify',
          meta: { title: '识别管理' }
        }
      ]
    }
  ]
});
